export default __webpack_public_path__ + "static/media/trash-02.17f1a98a.svg";